export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-stone-100 text-stone-700">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://static.readdy.ai/image/dc9fac24fb94f27d5caab4f8d511ee93/e75238be69d7d493f2e8bb082a5394f9.png" 
                alt="MindClear Logo" 
                className="h-10 w-10 object-contain"
              />
              <span className="text-xl font-bold text-stone-900">ADHD Testing by AltaLumé</span>
            </div>
            <p className="text-stone-600 text-sm leading-relaxed mb-4">
              Professional online ADHD testing from AltaLumé. Fast, confidential, and convenient.
            </p>
          </div>

          <div>
            <h3 className="font-bold text-base mb-4 text-stone-900">Services</h3>
            <ul className="space-y-2">
              <li>
                <button onClick={() => scrollToSection('who-should-test')} className="text-stone-600 hover:text-violet-600 text-sm transition-colors cursor-pointer whitespace-nowrap">
                  ADHD Assessment
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('how-it-works')} className="text-stone-600 hover:text-violet-600 text-sm transition-colors cursor-pointer whitespace-nowrap">
                  How It Works
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('pricing')} className="text-stone-600 hover:text-violet-600 text-sm transition-colors cursor-pointer whitespace-nowrap">
                  Pricing Plans
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('benefits')} className="text-stone-600 hover:text-violet-600 text-sm transition-colors cursor-pointer whitespace-nowrap">
                  Benefits
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-stone-600 hover:text-violet-600 text-sm transition-colors cursor-pointer whitespace-nowrap font-semibold">
                  Get Started
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-bold text-base mb-4 text-stone-900">Stay Updated</h3>
            <p className="text-stone-600 text-sm mb-4">Get ADHD insights and updates delivered to your inbox.</p>
            <div className="flex gap-2">
              <input
                type="email"
                placeholder="Your email"
                className="flex-1 px-4 py-2 rounded-lg bg-white border border-stone-300 focus:outline-none focus:ring-2 focus:ring-violet-400 text-stone-800 placeholder-stone-400 text-sm"
              />
              <button className="bg-violet-600 text-white px-4 py-2 rounded-lg font-semibold hover:bg-violet-700 transition-colors whitespace-nowrap">
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          </div>
        </div>

        <div className="border-t border-stone-200 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-stone-400 text-sm">
              © 2026 AltaLumé Mental Health. All rights reserved.
            </p>
            <div className="flex flex-wrap justify-center gap-6 text-sm">
              <a href="/privacy" className="text-stone-500 hover:text-violet-600 transition-colors whitespace-nowrap">Privacy Policy</a>
              <a href="/terms" className="text-stone-500 hover:text-violet-600 transition-colors whitespace-nowrap">Terms of Service</a>
              <a href="/hipaa-notice" className="text-stone-500 hover:text-violet-600 transition-colors whitespace-nowrap">HIPAA Notice</a>
            </div>
            <div className="flex items-center">
              <a href="https://www.legitscript.com/websites/?checker_keywords=altalume.com" target="_blank" rel="nofollow" title="Verify LegitScript Approval for www.altalume.com">
                <img src="https://static.legitscript.com/seals/49265453.png" alt="Verify Approval for www.altalume.com" width="73" height="79" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}